module.exports = __webpack_public_path__ + "media/YesICan.11c7b133.wav";